import Image from 'next/legacy/image';

import { Container, NextLink } from '@/atoms';
import { Button, WithPaperBorder } from '@/molecules';

import type { ImageProps } from 'next/legacy/image';
import type { FunctionComponent } from 'react';
import type { TypeBannerStripCompleteProps } from './types';

/**
 * BannerStripComplete
 */
export const BannerStripComplete: FunctionComponent<
  TypeBannerStripCompleteProps
> = ({
  className = '',
  image,
  children,
  button,
  borderColor,
  borderHeight = 20,
  border,
  bottom,
  top,
  id,
  bgColor = 'inherit',
  textColor = 'inherit',
}: TypeBannerStripCompleteProps) => (
  <WithPaperBorder
    id={id}
    top={top}
    bottom={bottom}
    border={border}
    borderHeight={borderHeight}
    borderColor={borderColor}
  >
    <Container
      id={id}
      wrapper
      padding="p-2"
      className="w-full"
      classNameWrapper={`\
        flex flex-col md:!flex-row gap-6 text-center items-center justify-center relative u-headline u-headline--h3 \
        ${className}\
      `}
      style={{
        color: textColor,
        backgroundColor: bgColor,
        paddingBlock: top || bottom ? `${borderHeight + 20}px` : '20px',
        paddingInline: '16px',
      }}
    >
      {image && (
        <div className="hidden md:block">
          <Image
            src={image.src}
            width={image.width as ImageProps['width']}
            height={image.height as ImageProps['height']}
            alt={image?.alt ?? ''}
          />
        </div>
      )}

      {children}

      {button && button?.href && button?.label && (
        <NextLink href={button.href} passHref>
          <Button as="a" variant={button.style} negative={button.negative}>
            {button.label}
          </Button>
        </NextLink>
      )}
    </Container>
  </WithPaperBorder>
);

BannerStripComplete.displayName = 'BannerStripComplete';
